import React from 'react';
import Button from "../button";
import accounting from 'accounting';
import moment from "moment";
import CenteredDots from "../General/centeredDots";
import '../../style/advancedDisbursementsTab.css';
import CustomModal from "../General/customModal";
import AdvancedDisbursementsFormHOC from '../../containers/AdvancedDisbursements/advancedDisbursementsFormHOC';
import NotificationsList from "../General/notificationsList";
import AdvanceDisbursementsOverviewTable from "../AdvancedDisbursements/advanceDisbursementsOverviewTable";
import CustomTable from "../General/customTable/CustomTable";
import {ADVANCE_DISBURSEMENTS_TRANSITIONAL_STATUS, CURRENCY} from "../../helpers/variables";

const columns = [
    {propertyName: "expenseTypeName", header: "Disbursement Type"},
    {propertyName: "amount", header: "Amount", formatter: (row) => accounting.formatMoney(row.amount, CURRENCY, 2)},
    {propertyName: "disbursementStatusName", header: "Status", formatter: (ad) => (
            ad.paymentInstructionId && ad.disbursementStatusMachineName === "approved" ?
                ADVANCE_DISBURSEMENTS_TRANSITIONAL_STATUS
                :
                ad.disbursementStatusName
        )},
    {propertyName: "previouslySettledAmount", header: "Settled Amount", formatter: (row) => accounting.formatMoney(row?.disbursementDetails?.settledAmount, CURRENCY, 2)},
    {propertyName: "creationDate", header: "Date Created", formatter: (row) => moment(row.creationDate).format("DD/MM/YYYY")},
    {propertyName: "paymentDate", header: "Date Paid", formatter: (row) => (row.paymentDate? moment(row.paymentDate).format("DD/MM/YYYY") : "")},
    {propertyName: "paymentInstructionId", header: "Payment Reference", formatter: (row) => (row.paymentInstructionId? row.paymentInstructionId : "")},
];

const AdvancedDisbursementTab = (props) => {
    const {dismissSuccessAlertMessage, onDownloadStatement, fetchingStatementMessages,disableAdvancedDisbursementsButton} = props;
    const tableColumns = (
        props.isAragUser
        && props.applicationPolicyStatus
        && (
            props.applicationPolicyStatus.toLowerCase() === "abandoned"
            || props.applicationPolicyStatus.toLowerCase() === "closed"
        )
            ? [
                ...columns,
                {propertyName: "lawsysDisbursementId", header: "Lawsys Disbursement ID", formatter: (ad) => (
                        ad.lawsysDisbursementId ? ad.lawsysDisbursementId : ''
                    )},
            ]
            : columns
    )

    return (
        <div className="advanced-disbursements-tab-content ">
            {props.advanceDisbursementsTab.successPatchMessage && (
                <NotificationsList
                    variant={"success"}
                    position={"centerLeft"}
                    notifications={[
                        {
                            key: "message",
                            label: props.advanceDisbursementsTab.successPatchMessage,
                            callback: dismissSuccessAlertMessage
                        }
                    ]}
                />
            )}
            <CustomModal
                isOpen={props.advanceDisbursementsTab.isAdModalOpen}
                content={
                    <AdvancedDisbursementsFormHOC editingForm={true} applicationId={props.applicationPolicyId} cancel={props._closeAdModal}/>
                }
                handleClose={props._closeAdModal}
            />
            {(
                props.loggedInUserRole === 'Solicitor'
                && props.applicationPolicyStatus === 'Live'
            ) && (
                <div className="col-sm-12 mb-15">
                    <Button
                        clickHandler={props._openAdvancedDisbursementsApplicationModal}
                        wrapper="btn-wrapper"
                        btnType="button" btnStyle={'btn btn-primary btn-xs sharp yellow' + ' ' + ((props.applicationPolicyStatus === 'Closed' || props.applicationPolicyStatus === 'Abandoned')?'btn-disabled':'')}
                        label="New Advance Disbursement Request"
                        disabled={disableAdvancedDisbursementsButton}
                    />
                </div>
            )
            }
            <div className={"col-sm-12"}>
                <AdvanceDisbursementsOverviewTable
                    totalNumberOfAdvancedDisbursements={props.totalNumberOfAdvancedDisbursements}
                    totalNumberOfApplied={props.totalNumberOfApplied}
                    totalNumberOfApproved={props.totalNumberOfApproved}
                    totalSettledRecords={props.totalSettledRecords}
                    totalValueOfAdvancedDisbursements={props.totalValueOfAdvancedDisbursements}
                    totalValueOfApplied={props.totalValueOfApplied}
                    totalValueOfApproved={props.totalValueOfApproved}
                    totalSettledValue={props.totalSettledValue}
                    totalPartSettledValue={props.totalPartSettledValue}
                    totalRejectedValue={props.totalRejectedValue}
                    totalRejectedRecords={props.totalRejectedRecords}
                    totalProcessingRecords={props.totalProcessingRecords}
                    totalPartSettledRecords={props.totalPartSettledRecords}
                    totalProcessingValue={props.totalProcessingValue}
                    totalPaidRecords={props.totalPaidRecords}
                    totalPaidValue={props.totalPaidValue}
                    isAragUser={props.isAragUser}
                />
            </div>
            {(
                !props.fetchingAdvancedDisbursements
                && !fetchingStatementMessages
            ) && (
                <div className={"col-sm-12 form-group"}>
                    <Button
                        clickHandler={onDownloadStatement}
                        wrapper="btn-wrapper"
                        btnType="button"
                        btnStyle={'btn btn-primary btn-xs sharp yellow'}
                        label="Download Statement"
                    />
                </div>
            )}
            {
                props.fetchingAdvancedDisbursements && props.advancedDisbursements.length === 0 ?
                    <CenteredDots/>
                    :
                    null
            }
            {
                props.advancedDisbursements.length > 0?
                    <div className="col-sm-12">
                        <CustomTable
                            hasActions
                            actions={[
                                {
                                    key: 'details',
                                    label: 'Details',
                                    callback: (ad) => props._handleRowClick(ad)
                                },
                            ]}
                            accordionItemHeaderFormatter={(row) => (
                                `Disbursement Type: ${row.expenseTypeName}`
                            )}
                            loading={props.fetchingAdvancedDisbursements}
                            fixed
                            responsive
                            striped
                            columns={tableColumns}
                            data={props.advancedDisbursements}
                        />
                    </div>
                    :
                    null
            }
        </div>
    )
};

export default AdvancedDisbursementTab;